module.exports = __webpack_public_path__ + "static/img/22222.8803dd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/video/20251009/22222.png
// module id = 4jlg
// module chunks = 7